<ol class="breadcrumb m-0 px-2 align-self-center">
  <ng-container *ngFor="let item of breadcrumbItems; let i = index">
    <li class="breadcrumb-item fw-600" *ngIf="!item.active"><a href="javascript: void(0);" (click)="handleBreadCrumd(item, i)">{{ item.label }}</a>
    </li>
    <li class="breadcrumb-item fw-600 active" *ngIf="item.active">{{ item.label }}
    </li>
  </ng-container>
</ol>